import styled, { css } from 'styled-components';
import { StatelessSideNav } from '@amzn/storm-ui';

export const StyledSideNav = styled(StatelessSideNav)`
  height: 100%;
`;

export const MobilePivotNavWrapper = styled.div`
  & nav {
    padding-inline-start: ${({ theme }) => theme.spacing.small.mobile};
  }
`;

export const GroupLinksWrapper = styled.div<{ hasLabel?: boolean }>`
  ${({ hasLabel }) =>
    hasLabel &&
    css`
      padding-inline-start: ${({ theme }) => theme.spacing.xxsmall.default};
    `};

  > span {
    width: 100%;
  }
`;
